import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import Header from 'components/Header';
import { preserveLeadingSpaces } from 'components/menu/PolicyManagement';
import Loading from 'components/Loading';
import Tiptap from 'components/Tiptap/Tiptap';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // 이전 버튼 아이콘
import Footer from 'components/Footer';
import { getTermsAPI } from 'apis/policy/policyAPI';
import { useTranslation } from 'react-i18next';

export default function TermService() {
  const [termsContent, setTermsContent] = useState<string>('');
  const termsEditorRef = useRef<any>(null);
  const navigate = useNavigate();
  // 다국어
  const { t } = useTranslation();

  const handleGoBack = () => {
    navigate(-1); // 이전 페이지로 이동
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const getTermsAPIResponse = await getTermsAPI();
        const { dates, content } = getTermsAPIResponse.data;
        // 이용약관
        setTermsContent(preserveLeadingSpaces(content || ''));
      } catch (error) {
        console.error('데이터 가져오기 실패 :', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div
      style={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header를 클릭하면 메인페이지로 이동 */}
      <Header />
      {/* 경계선 */}
      <Divider />
      <Box
        style={{
          flex: '1', // 남은 공간을 차지하도록 설정
          width: '100%',
          maxWidth: '1920px',
          margin: '16px auto'
        }}
        paddingX={8}
      >
        <Box display="flex" flexDirection="row" gap={1} marginBottom={2}>
          <IconButton onClick={handleGoBack} color="primary" aria-label="back">
            <ArrowBackIcon />
          </IconButton>
          {/* 이용약관 */}
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography variant="h5" fontWeight="bold">
              {t('footer.term')}
            </Typography>
          </Box>
        </Box>

        {/* 데이터가 존재하지 않을 때 로딩 메시지 또는 스피너 표시 */}
        {/*<Box boxShadow={1} borderRadius={1} bgcolor={theme.palette.tiptap.main}>*/}
        <Box boxShadow={1} borderRadius={1}>
          {!termsContent ? <Loading /> : <Tiptap ref={termsEditorRef} content={termsContent} editable={false} maxHeight="calc(100vh - 300px)" />}
        </Box>
      </Box>
      <Footer maxWidth={1920} />
    </div>
  );
}
